import React, { useEffect, useState } from "react";
import "./LoanDetails.css";
import {
  Typography,
  FormControl,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import {
  inputLableStyle,
  formControlStyle,
} from "../../../../calculatorStyleData";

const LoanDetails = ({ onData }) => {
  const [principal, setPrincipal] = useState(3000000); // Outstanding Principal Amount
  const [currentInterestRate, setCurrentInterestRate] = useState(10.25); // Current Interest Rate (%)
  const [currentTenure, setCurrentTenure] = useState(185); // Current Outstanding Tenure (Months)
  const [newInterestRate, setNewInterestRate] = useState(5); // Illustrative Interest Rate (%)
  const [newTenure, setNewTenure] = useState(240); // Required Tenure (Months)

  const formatter = (value) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0, // Ensure no decimals
      maximumFractionDigits: 0, // Ensure no decimals
    }).format(value);
  };

  const handleCalculate = () => {
    // EMI Calculation Formula
    const calculateEMI = (P, annualRate, N) => {
      const R = annualRate / (12 * 100); // Convert annual interest rate to monthly
      return (P * R * Math.pow(1 + R, N)) / (Math.pow(1 + R, N) - 1);
    };

    // Calculate Current Loan EMI and Total Paid
    const emiCurrent = calculateEMI(
      principal,
      currentInterestRate,
      currentTenure
    );
    const totalCurrent = emiCurrent * currentTenure;

    // Calculate New Loan EMI and Total Paid
    const emiNew = calculateEMI(principal, newInterestRate, newTenure);
    const totalNew = emiNew * newTenure;

    // Calculate Savings
    const savings = totalCurrent - totalNew;

    // Form Data Object
    const formData = {
      principal,
      currentInterestRate,
      currentTenure,
      newInterestRate,
      newTenure,
      savedAmount: isNaN(savings) ? 0 : formatter(savings),
      currentEMI: isNaN(emiCurrent) ? 0 : formatter(emiCurrent),
      newEMI: isNaN(emiNew) ? 0 : formatter(emiNew),
      totalCurrentAmount: isNaN(totalCurrent) ? 0 : formatter(totalCurrent),
      totalNewAmount: isNaN(totalNew) ? 0 : formatter(totalNew),
    };

    // Pass formData to the parent component
    if (onData) onData(formData);
  };

  useEffect(() => {
    handleCalculate();
  }, [
    principal,
    currentInterestRate,
    currentTenure,
    newInterestRate,
    newTenure,
  ]);

  const formatCurrency = (value) => {
    return value.toLocaleString("en-IN");
  };

  const handleAmountChange = (e, setter) => {
    const value = e.target.value.replace(/,/g, ""); // Remove commas
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = Number(value); // Convert to number
      if (numericValue <= 5000000) {
        // Restrict to maximum 50,00,000
        setter(numericValue);
      }
    }
  };

  return (
    <>
      <div
        id="loan_details__container"
        className=" loan_details__content__box rounded py-4 px-3"
      >
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: "24px",

            fontFamily: "'Archivo', sans-serif",
          }}
          className="px-2 fw-bold"
        >
          Your Current Loan
        </Typography>
        <div className="d-flex flex-column gap-1 mt-1">
          <div className="details_box p-2">
            <p style={inputLableStyle} className="mb-1">
              Outstanding Loan Amount (₹):
            </p>
            <FormControl fullWidth sx={formControlStyle}>
              <OutlinedInput
                id="outlined-adornment-amount"
                fullWidth
                size="small"
                startAdornment={
                  <InputAdornment position="start">
                    <span className="archivo">&#8377;</span>
                  </InputAdornment>
                }
                value={formatCurrency(principal)} // Display value with commas
                onChange={(e) => handleAmountChange(e, setPrincipal)}
              />
            </FormControl>
          </div>
          <div className="details_box p-2">
            <p style={inputLableStyle} className="mb-1">
              Current Interest Rate (APR %)
            </p>
            <FormControl fullWidth sx={formControlStyle}>
              <OutlinedInput
                id="outlined-adornment-amount"
                fullWidth
                size="small"
                sx={{
                  fontFamily: "'Archivo',sans-serif",
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <span className="archivo">%</span>
                  </InputAdornment>
                }
                value={currentInterestRate || 0}
                onChange={(e) => {
                  let value = e.target.value.replace(/,/g, ""); // Remove commas

                  if (/^\d*\.?\d*$/.test(value)) {
                    if (value === "") {
                      setCurrentInterestRate(""); // Allow empty field temporarily
                    } else {
                      setCurrentInterestRate(value.replace(/^0+/, "") || "0"); // Remove leading zero
                    }
                  }
                }}
                onFocus={() =>
                  currentInterestRate === "0" && setCurrentInterestRate("")
                } // Empty field on focus
                onBlur={() =>
                  setCurrentInterestRate(
                    currentInterestRate === "" ? "0" : currentInterestRate
                  )
                }
              />
            </FormControl>
          </div>
          <div className="details_box  p-2">
            <p style={inputLableStyle} className="mb-1">
              Current Outstanding Tenure(Months):
            </p>
            <FormControl fullWidth sx={formControlStyle}>
              <OutlinedInput
                id="outlined-adornment-amount"
                fullWidth
                size="small"
                value={currentTenure}
                onChange={(e) => handleAmountChange(e, setCurrentTenure)}
              />
            </FormControl>
          </div>

          <div className="px-2 mt-1">
            <div
            // className={`origination_details ${
            //   addOrginationOpen === true ? "d-flex" : "d-none"
            // }  flex-column gap-1 mt-4`}
            >
              <div className="details_box ">
                <div className="pt-3 ">
                  <Typography
                    sx={{
                      fontSize: "16px",
                      lineHeight: "24px",

                      fontFamily: "'Archivo', sans-serif",
                    }}
                    className=" fw-bold"
                  >
                    Details of Loan
                  </Typography>
                </div>
                <div className="new-loan-box pt-2">
                  <p style={inputLableStyle} className="mb-1">
                    New Interest Rates (%):
                  </p>
                  <FormControl fullWidth sx={formControlStyle}>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      fullWidth
                      size="small"
                      endAdornment={
                        <InputAdornment position="end">
                          <span className="archivo">%</span>
                        </InputAdornment>
                      }
                      value={newInterestRate || 0}
                      onChange={(e) => {
                        let value = e.target.value.replace(/,/g, ""); // Remove commas

                        if (/^\d*\.?\d*$/.test(value)) {
                          if (value === "") {
                            setNewInterestRate(""); // Allow empty field temporarily
                          } else {
                            setNewInterestRate(value.replace(/^0+/, "") || "0"); // Remove leading zero
                          }
                        }
                      }}
                      onFocus={() =>
                        newInterestRate === "0" && setNewInterestRate("")
                      } // Empty field on focus
                      onBlur={() =>
                        setNewInterestRate(
                          newInterestRate === "" ? "0" : newInterestRate
                        )
                      }
                    />
                  </FormControl>
                </div>
                <div className="new-loan-box pt-4">
                  <p style={inputLableStyle} className="mb-1">
                    Required Tenure (Months):
                  </p>
                  <FormControl fullWidth sx={formControlStyle}>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      fullWidth
                      size="small"
                      value={formatCurrency(newTenure || "")}
                      onChange={(e) => handleAmountChange(e, setNewTenure)}
                    />
                  </FormControl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanDetails;
